export interface NewsItem {
  id: string;
  title: string;
  date: string;
  summary: string;
  cover: string;
  relatedFilmId: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'n-20241008',
    title: '神宫寺奈绪新剧《夜航船》开播，悬疑氛围获观众好评',
    date: '2024-10-08',
    summary:
      '由神宫寺奈绪领衔主演的悬疑剧《夜航船》正式开播，首播两集便以紧凑的叙事和细腻的表演收获大量好评，相关话题迅速登上热搜。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20news%20feature%20image%20of%20a%20night%20ferry%20on%20deep%20blue%20ocean%20with%20warm%20orange%20lights%2C%20editorial%20entertainment%20banner%20style&width=800&height=500&seq=news-yhc-01&orientation=landscape',
    relatedFilmId: 'yhc',
    content: [
      '由神宫寺奈绪领衔主演的悬疑剧《夜航船》于本周正式开播。剧集以一艘夜间渡轮为舞台，讲述六名乘客在航行途中逐渐暴露彼此秘密的故事。首播两集播出后，紧凑的节奏与克制的表演风格收获不少观众的肯定。',
      '神宫寺奈绪在剧中饰演一名身份成谜的乘客。为了贴近角色，她在开拍前特意体验了多次夜间渡轮的航行，并在采访中表示：「真正让人不安的从来不是黑暗，而是黑暗里那个不肯说话的自己。」',
      '据平台方透露，《夜航船》上线首日播放量表现亮眼，相关话题多次进入热搜榜单。剧集共九集，将于每周更新两集。',
    ],
  },
  {
    id: 'n-20241001',
    title: '《深海回响》票房口碑双丰收，神宫寺奈绪演技成热议焦点',
    date: '2024-10-01',
    summary:
      '电影《深海回响》上映后持续走高，影片以细腻的表演与震撼的水下场景赢得观众认可，神宫寺奈绪的演技成为讨论焦点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20news%20banner%20of%20a%20diver%20silhouette%20in%20deep%20blue%20water%20with%20a%20warm%20orange%20light%20beam%2C%20editorial%20entertainment%20style&width=800&height=500&seq=news-dhyx-01&orientation=landscape',
    relatedFilmId: 'dhyx',
    content: [
      '电影《深海回响》上映以来票房与口碑持续走高。影片围绕一场跨越十年的深海救援行动展开，将个人秘密与一座沿海城市的命运交织在一起。',
      '神宫寺奈绪在片中饰演潜水工程师一角，为完成大量水下戏份，她进行了为期数月的潜水与体能训练。导演松本凌在采访中称赞她「把压力与克制演到了骨子里」。',
      '有影评人认为，《深海回响》在类型片的框架下完成了一次情感层面的深潜，是近年来不可多得的诚意之作。',
    ],
  },
  {
    id: 'n-20240920',
    title: '神宫寺奈绪凭《东京纪事》获最佳女主角提名',
    date: '2024-09-20',
    summary:
      '凭借在都市剧《东京纪事》中的表现，神宫寺奈绪获得年度最佳女主角提名，这也是她连续第三年入围该奖项。',
    cover:
      'https://readdy.ai/api/search-image?query=elegant%20award%20ceremony%20spotlight%20in%20warm%20orange%20and%20deep%20blue%2C%20editorial%20entertainment%20news%20banner%20with%20space%20for%20text&width=800&height=500&seq=news-djjs-01&orientation=landscape',
    relatedFilmId: 'djjs',
    content: [
      '年度影视盛典提名名单近日公布，神宫寺奈绪凭借都市剧《东京纪事》中的表演获得最佳女主角提名，这也是她连续第三年入围该奖项。',
      '在《东京纪事》中，她饰演一间深夜咖啡馆的店主，是全剧五位主角之间的情感锚点。剧评人认为，她的表演「安静而有重量」，用极少的台词撑起了整部剧的温度。',
      '提名公布后，神宫寺奈绪在社交平台发文感谢剧组与观众：「每一个深夜独自坐着的人，都值得被好好听一次。」',
    ],
  },
  {
    id: 'n-20240830',
    title: '综艺《星光旅程》第二季官宣，神宫寺奈绪确认回归',
    date: '2024-08-30',
    summary:
      '广受好评的旅行类综艺《星光旅程》宣布启动第二季制作，神宫寺奈绪已确认回归，新一季将前往更多小众目的地。',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20variety%20show%20banner%20with%20warm%20orange%20spotlights%20and%20deep%20blue%20backdrop%2C%20energetic%20editorial%20entertainment%20style&width=800&height=500&seq=news-xgzl-01&orientation=landscape',
    relatedFilmId: 'xgzl',
    content: [
      '旅行类综艺《星光旅程》正式官宣第二季启动。节目主打「真实旅行 + 即兴表演」，第一季凭借松弛的氛围与真实的笑点收获良好口碑。',
      '神宫寺奈绪确认回归常驻阵容。据了解，新一季将前往更多小众目的地，并加入「无剧本」环节，考验嘉宾的临场反应。',
      '节目组表示，第二季预计于明年开播，具体拍摄路线将在后续陆续公布。',
    ],
  },
  {
    id: 'n-20240812',
    title: '神宫寺奈绪加盟电影《雾都来信》，挑战双时间线叙事',
    date: '2024-08-12',
    summary:
      '电影《雾都来信》公布主演阵容，神宫寺奈绪将在片中挑战双时间线叙事，演绎同一角色跨越二十年的变化。',
    cover:
      'https://readdy.ai/api/search-image?query=mysterious%20news%20banner%20of%20a%20hand%20holding%20an%20old%20letter%20in%20foggy%20deep%20blue%20city%20with%20warm%20orange%20glow%2C%20editorial%20style&width=800&height=500&seq=news-wdll-01&orientation=landscape',
    relatedFilmId: 'wdll',
    content: [
      '电影《雾都来信》公布主演阵容，神宫寺奈绪确认出演女主角。影片围绕一封迟到二十年的信展开，采用双时间线叙事结构。',
      '为了呈现同一角色跨越二十年的变化，神宫寺奈绪需要在同一部影片中完成不同年龄段的演绎。她坦言这是「一次关于时间的功课」。',
      '导演河合隆表示，选择她正是因为「她身上有一种可以被时间经过的感觉」。影片预计于明年登陆院线。',
    ],
  },
  {
    id: 'n-20240715',
    title: '神宫寺奈绪接受专访：谈表演中的「留白」与自我',
    date: '2024-07-15',
    summary:
      '在一次深度专访中，神宫寺奈绪分享了自己对表演的理解，认为「留白」是角色最珍贵的部分，也谈及多年来的自我成长。',
    cover:
      'https://readdy.ai/api/search-image?query=quiet%20editorial%20interview%20scene%20with%20a%20silhouette%20seated%20in%20warm%20orange%20light%20against%20deep%20blue%20shadows%2C%20minimal%20style&width=800&height=500&seq=news-interview-01&orientation=landscape',
    relatedFilmId: 'jmos',
    content: [
      '在一次深度专访中，神宫寺奈绪谈到了自己对表演的理解。她认为，一个角色最珍贵的部分往往是「没有被写出来的那部分」。',
      '「我演的从来不是台词，而是台词之间的沉默。」她说，「观众真正记住的，是那些他们自己去填满的空白。」',
      '谈及多年的成长，她坦言自己不再急于证明什么，「现在更愿意让角色慢慢长出来，而不是一开始就用力过猛。」',
    ],
  },
  {
    id: 'n-20240620',
    title: '《静默之夏》登陆国际影展，海外媒体给出高分评价',
    date: '2024-06-20',
    summary:
      '文艺片《静默之夏》受邀参加国际影展特别展映，影片近乎默片式的表达获得海外媒体关注，多家媒体给出高分评价。',
    cover:
      'https://readdy.ai/api/search-image?query=cultural%20film%20festival%20banner%20with%20warm%20orange%20stage%20light%20and%20deep%20blue%20curtains%2C%20elegant%20editorial%20style&width=800&height=500&seq=news-jmos-01&orientation=landscape',
    relatedFilmId: 'jmos',
    content: [
      '文艺片《静默之夏》受邀参加国际影展特别展映单元。影片以一个没有对白的夏天为背景，讲述一段被时间搁置的告别。',
      '神宫寺奈绪在片中采用近乎默片式的表演，海外媒体评论称她「用眼神完成了一场完整的独白」。',
      '影片导演小林纪子表示，这次展映让作品被更多不同文化背景的观众看到，「沉默原来是可以被翻译的」。',
    ],
  },
  {
    id: 'n-20240510',
    title: '幕后花絮曝光：神宫寺奈绪为《暗流之城》体验记者生活',
    date: '2024-05-10',
    summary:
      '《暗流之城》剧组公开幕后花絮，神宫寺奈绪为贴近记者角色，曾跟随真实记者采访数周，认真态度获剧组称赞。',
    cover:
      'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20crew%20scene%20on%20a%20rainy%20deep%20blue%20city%20street%20with%20warm%20orange%20lights%2C%20editorial%20cinematic%20style&width=800&height=500&seq=news-anliu-01&orientation=landscape',
    relatedFilmId: 'anliu',
    content: [
      '《暗流之城》剧组公开了一组幕后花絮。画面中，神宫寺奈绪身穿简洁外套，在雨夜街头反复排练同一场戏。',
      '据工作人员透露，为贴近剧中记者一角，她在开拍前跟随真实记者采访数周，记录了厚厚一本笔记。「她问的问题比我们采访别人时还细。」',
      '导演河合隆表示，正是这种对细节的执着，让角色在镜头前显得格外可信。',
    ],
  },
];